import { monthOptions } from "../../../config";

export const formatRupiah = (value) => {
  if (value === null || value === undefined) return "Rp 0";
  return `Rp ${Number(value).toLocaleString("id-ID")}`;
};

export const tableConfig = [
  {
    name: "category",
    label: "",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          visibility: "hidden",
          height: 0,
          padding: 0,
        },
      }),
    },
  },
  { name: "jan", label: "JAN", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "feb", label: "FEB", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "mar", label: "MAR", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "apr", label: "APR", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "may", label: "MAY", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "jun", label: "JUN", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "jul", label: "JUL", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "aug", label: "AUG", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "sep", label: "SEP", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "oct", label: "OCT", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "nov", label: "NOV", options: { sort: false, customBodyRender: formatRupiah } },
  { name: "dec", label: "DEC", options: { sort: false, customBodyRender: formatRupiah } },
  {
    name: "totalYear",
    label: "YEAR TO DATE",
    options: { sort: false, customBodyRender: formatRupiah },
  },
];

export const transformResponseYearsToDateToTable = (val = []) => {
  if (!Array.isArray(val)) return [];

  return val.map((item, index) => ({
    no: index + 1,
    category: item.partCategoryValue,
    jan: item.jan,
    feb: item.feb,
    mar: item.mar,
    apr: item.apr,
    may: item.may,
    jun: item.jun,
    jul: item.jul,
    aug: item.aug,
    sep: item.sep,
    oct: item.oct,
    nov: item.nov,
    dec: item.dec,
    totalYear: item.totalYear,
  }));
};
